import React from 'react';
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {Check} from "@sparkware/app-utils";
import {RelatedSitesWrapperBox} from "./boxes/related-sites-wrapper.box";
import {RelatedSiteComponent} from "./related-site.component";

interface RelatedSiteComponentProps {
    headerHeight?: number;
}

export const RelatedSitesComponent: React.FC<RelatedSiteComponentProps> = observer((props) => {
    const services = useServices();
    let relatedSites = services.configuration.data.header.related_sites;
    if (Check.isEmpty(relatedSites)) {
        return null;
    }

    return (
        <RelatedSitesWrapperBox headerHeight={props.headerHeight}>
            {relatedSites.map((relatedSiteConfig) => <RelatedSiteComponent key={relatedSiteConfig.linkId} config={relatedSiteConfig}/>)}
        </RelatedSitesWrapperBox>
    );
});